import { render } from "./RegistrationLastStepPage.vue?vue&type=template&id=0925044d&scoped=true"
import script from "./RegistrationLastStepPage.vue?vue&type=script&lang=js"
export * from "./RegistrationLastStepPage.vue?vue&type=script&lang=js"

import "./RegistrationLastStepPage.vue?vue&type=style&index=0&id=0925044d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0925044d"]])

export default __exports__